import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { unformatPhoneNumber } from "../../utils/phoneNumber";
import { baseUrl } from "../../config/apiConfig";

export const registerUser = createAsyncThunk("user/register", async (user) => {
  const userData = { ...user, phone: unformatPhoneNumber(user.phone) };
  const response = await axios.post(`${baseUrl}/api/auth/register`, userData);
  return response.data;
});

export const loginUser = createAsyncThunk("user/login", async (user) => {
  const response = await axios.post(`${baseUrl}/api/auth/login`, user);
  return response.data;
});

export const verifyOTP = createAsyncThunk("user/verifyOTP", async ({ email, otp, purpose }) => {
  const response = await axios.post(`${baseUrl}/api/otp/verify-otp`, {
    email,
    otp,
    purpose,
  });
  return response.data;
});

export const refreshAccessToken = createAsyncThunk("user/refreshToken", async (refreshToken) => {
  const response = await axios.post(`${baseUrl}/api/auth/refresh`, {
    refreshToken: refreshToken,
  });
  return response.data;
});

const initialState = {
  user: {
    id: "",
    name: "",
    email: "",
    phone: "",
    userType: "",
    address: null,
    taxNumber: null,
  },
  accessToken: null,
  refreshToken: null,
  isLoading: false,
  error: null,
  isLogin: false,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    logout: (state, action) => {
      state.isLogin = false;
      state.user = {
        id: "",
        name: "",
        email: "",
        phone: "",
        userType: "",
        address: null,
        taxNumber: null,
      };
      state.accessToken = null;
      state.refreshToken = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(registerUser.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(registerUser.fulfilled, (state, action) => {
      state.isLoading = false;
      // OTP gönderildi, henüz token yok
      // Token OTP doğrulandıktan sonra verifyOTP'de kaydedilecek
      state.error = null;
    });
    builder.addCase(registerUser.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });
    builder.addCase(loginUser.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(loginUser.fulfilled, (state, action) => {
      state.isLoading = false;
      // OTP gönderildi, henüz token yok
      // Token OTP doğrulandıktan sonra verifyOTP'de kaydedilecek
      state.error = null;
    });
    builder.addCase(loginUser.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });
    builder.addCase(verifyOTP.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(verifyOTP.fulfilled, (state, action) => {
      state.isLoading = false;
      state.user = action.payload?.data?.user || {};
      state.accessToken = action.payload?.data?.accessToken || null;
      state.refreshToken = action.payload?.data?.refreshToken || null;
      state.isLogin = true;
      state.error = null;
    });
    builder.addCase(verifyOTP.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });
    builder.addCase(refreshAccessToken.fulfilled, (state, action) => {
      state.accessToken = action.payload?.data?.accessToken || null;
    });
    builder.addCase(refreshAccessToken.rejected, (state, action) => {
      // Refresh token başarısız olduğunda logout yapılacak
      state.accessToken = null;
      state.refreshToken = null;
      state.isLogin = false;
    });
  },
});

export const { logout } = userSlice.actions;

export default userSlice.reducer;
